<template>
  <div class="FavoriteBox">
    <div class="title">
      <h2>收藏夹</h2>
    </div>
    <div class="search">
      <!-- <button @click="close">关闭loading</button> -->
      <el-input 
        placeholder="输入关键字进行查找" 
        v-model="searchVal" 
        @keyup.enter.native="searchChange"
        @change="searchChange"
        :class="['searchInput', isDark ? 'darkInput' : '']"
      >
        <div slot="suffix" class="searchIcon">
          <i class="el-icon-search"></i>
        </div> 
      </el-input>
    </div>
    <div class="talksBox scrollStyle" ref="collectRef">
      <el-empty description="暂无收藏" v-if="collectListData.length == 0"></el-empty>
      <template v-else>
        <div v-for="(item, index) in collectListData" :key="index">
          <Msg 
            :news="item" 
            :showAvatar="false" 
            :isHoverAction="true"
            msgType="coll"
            :itemKey="{
              textTitle: 'input',
              textContent: 'reply'
            }"
            @show="showCollDtl"
            @del="delColl"
          >
          </Msg>
        </div>
      </template>
    </div>
    <!-- 收藏详情 -->
    <el-dialog
      :visible.sync="dialogDtlVisible"
      title="收藏详情"
      width="50%"
      :fullscreen="false"
      destroy-on-close
      class="mobile-dialog"
    >
      <CollectDtl 
        :collectDtl="collectDetail" 
        @closeDtl="closeDtl"
      >
      </CollectDtl>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
import Msg from '../+components/Msg';
import { mapState, mapMutations, mapActions } from 'vuex';
import CollectDtl from '../+components/collectDtl';

export default {
  name: 'Favorite',
  components: { Msg, CollectDtl },
  props: {},
  data () {
    return {
      collectDel: api.collectDel,
      searchVal: '',
      loadingInstance: null,
      dialogDtlVisible: false,
      collectDetail: {},
    }
  },
  computed: {
    ...mapState('userAbout', ['collectListData']),
    ...mapState('comAbout', ['isDark']),
  },
  watch: {},
  created () {},
  mounted () {
    // loading效果
    const collectRef = this.$refs.collectRef;
    this.loadingInstance = this.$loading({
      target: collectRef,
      background: '#f1f7fe',
    })
    this.getCollectList(this.searchVal);
    this.$nextTick(() => {
      this.loadingInstance.close();
    })
  },
  methods: {
    ...mapMutations('userAbout', ['setCollectList', 'deleteCollect']),
    ...mapActions('userAbout', ['getCollectList']),
    // 查看收藏详情
    showCollDtl(item) {
      this.collectDetail = item;
      this.dialogDtlVisible = true;
    },
    // 删除收藏
    delColl(item) {
      this.$confirm("删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: this.isDark ? 'darkMessage' : '',
      }).then(() => {
        this.collectDel({ ConversationId: item.conversationId })
          .then((res) => {
            if (res.success) {
              this.$message({
                message: `已删除`,
                type: "success",
              });
              this.closeDtl();
              this.deleteCollect(item.conversationId);
            } else {
              this.$message.error("删除失败：" + res.message);
            }
          })
      })
    },
    // 收起收藏详情
    closeDtl(){
      this.dialogDtlVisible = false;
      this.collectDetail = {};
    },
    // 充值
    payGood(item) {
      this.$emit('payGood', item);
    },
    // close() {
    //   this.loadingInstance.close();
    // },
    // 搜索收藏
    searchChange() {
      this.getCollectList(this.searchVal);
    },
  }
}
</script>

<style scoped lang="less">
.FavoriteBox {
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  .title {
    line-height: 24px;
    margin: 16px 0 8px;
    height: 22px;
    h2 {
      font-size: 18px;
      font-weight: 600;
    }
  }
  .search {
    margin: 4px 0 16px;
    height: 55px;
    .searchIcon {
      height: 55px;
      width: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 20px;
      }
    }
  }
  .talksBox {
    height: calc(100% - 22px - 55px);
    flex: 1;
    overflow-y: auto;
    padding-right: 3px;
    position: relative;

    // /* 针对整个滚动条 */ 
    // &::-webkit-scrollbar {  
    //   width: 3px; /* 滚动条的宽度 */  
    // }
    // /* 滚动条轨道 */  
    // &::-webkit-scrollbar-track {  
    //   // background: #f1f7fe; /* 滚动条轨道的背景色 */  
    //   background: transparent;
    // } 
    // /* 滚动条滑块 */  
    // &::-webkit-scrollbar-thumb {  
    //   // background: #f1f7fe; /* 滚动条滑块的颜色 */  
    //   background: transparent;
    //   border-radius: 5px; /* 滑块边缘的圆角 */  
    // }  
    // &:hover::-webkit-scrollbar-thumb {
    //   background: rgb(238, 238, 238); 
    // }
  }
}
@media screen and (max-width: 750px) {
  .mobile-dialog {
    max-width: 90%;
    margin: 0 auto;
    /deep/.el-dialog {
      width: 99% !important;
    }
  }
}
</style>
